export default __webpack_public_path__ + "static/product-dots-dark-9d3b43b4f0573e9f4994dc35c414d33f.jpg";